import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description MortgageLand icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { MortgageLand } from '@sravni/design-system-icons'
 *
 * <MortgageLand />
 * ```
 */
var MortgageLand = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "MortgageLand", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.32 9.333a3.917 3.917 0 0 1-7.834 0c0-1.132.474-2.84 1.272-4.267.395-.707.848-1.305 1.321-1.717.474-.413.92-.599 1.324-.599s.85.186 1.324.599c.473.412.926 1.01 1.321 1.717.798 1.427 1.272 3.135 1.272 4.267Z", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M10.402 15v-3.666M6.402 15.647c1.176-.388 4.103-.807 6.667 1.353", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" }))); });

export { MortgageLand };
//# sourceMappingURL=MortgageLand.js.map
